// extracted by mini-css-extract-plugin
export default {"container":"NoSearchResult_container__SJVcQ","emoji":"NoSearchResult_emoji__WjxLL","message":"NoSearchResult_message__DAhVo"};